import { Page } from 'components/Shared/Page'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Link, Stack } from '@mui/material'
import { isDeveloperMode } from 'utils/isDeveloperMode'
import { DashboardLocationSweepValidationGrid } from './DashboardLocationSweepValidationGrid'
import { useGetGroupPermission } from 'hooks/api/GroupPermission/useGetGroupPermission'
import { useEffect } from 'react'
import { setGroupPermissionAccess } from 'utils/setGroupPermission'
import { useGetFeatureAccess } from 'hooks/api/FeatureAccess/useGetFeatureAccess'
import { setFeatureAccess } from 'utils/setFeatureAccess'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'
import { useGetAllStates } from 'hooks/api/useGetAllStates'
import { useStateListStore } from 'stores/useStateListStore'
import { EmptyStateHomePage } from './EmptyStateHomePage'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'

export const DashboardPage = () => {
  const groupPermissionQuery = useGetGroupPermission()
  const { currentStateId } = useCurrentStateStore()
  const { data: states } = useGetAllStates()
  const { setStates } = useStateListStore()

  const featureAccessQuery = useGetFeatureAccess({
    currentStateId: currentStateId ?? 0,
    enabled: currentStateId !== undefined,
  })

  useEffect(() => {
    if (groupPermissionQuery.data) {
      setGroupPermissionAccess(groupPermissionQuery.data)
    }
  }, [groupPermissionQuery.data])

  useEffect(() => {
    if (featureAccessQuery.data && Array.isArray(featureAccessQuery.data)) {
      setFeatureAccess(featureAccessQuery.data)
    }
  }, [featureAccessQuery.data])

  // populate state list store when states are fetched
  useEffect(() => {
    if (states && Array.isArray(states)) {
      setStates(
        states.map((state) => ({
          stateName: state.stateName,
          stateId: state.id,
        }))
      )
    }
  }, [states])

  if (groupPermissionQuery.isPending) {
    return <ActivityIndicator />
  }
  const hasAccess =
    groupPermissionQuery.data?.groupName === 'Admin' &&
    groupPermissionQuery.data?.contests_LocationSweepstakesPermission

  const handleContactClick = () => {
    const url = 'https://www.jjgaming.com/contact/'
    window.open(url, '_blank')
  }

  return (
    <Page>
      <Stack spacing={4} my={4}>
        {isDeveloperMode() && (
          <Link
            to="/ComponentCatalog"
            component={RouterLink}
            width={'fit-content'}
          >
            Component Catalog
          </Link>
        )}
        <Link to="/PatronAccounts" component={RouterLink} width={'fit-content'}>
          Patrons
        </Link>
        <Box>
          {hasAccess ? (
            <DashboardLocationSweepValidationGrid />
          ) : (
            <EmptyStateHomePage onContactClick={handleContactClick} />
          )}
        </Box>
      </Stack>
    </Page>
  )
}
